/*
  Bloom homepage email popup. Progressive enhancement over a native customer form.
  - Shows once per visitor (30-day cooldown), after a delay or on exit-intent.
  - Reopens straight into the success state after a submit (server-rendered).
  - Scroll-lock + focus + Esc/backdrop close. Respects the Shopify theme editor.
*/
(() => {
  const root = document.querySelector('[data-email-popup]');
  if (!root) return;

  const KEY = 'bloom-emailpop-dismissed';
  const COOLDOWN = 30 * 24 * 60 * 60 * 1000; // 30 days
  const card = root.querySelector('.bloom-emailpop__card');
  const success = root.querySelector('[data-popup-success]');
  const designMode = window.Shopify && window.Shopify.designMode;
  let opened = false;
  let lastFocus = null;

  const recentlyDismissed = () => {
    try {
      const t = Number(localStorage.getItem(KEY));
      return t && Date.now() - t < COOLDOWN;
    } catch (e) {
      return false;
    }
  };
  const remember = () => {
    try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
  };

  const open = () => {
    if (opened) return;
    opened = true;
    lastFocus = document.activeElement;
    root.hidden = false;
    // force reflow so the transition runs
    void root.offsetWidth;
    root.classList.add('is-open');
    document.body.classList.add('bloom-emailpop-lock');
    const focusEl = root.querySelector('input[type="email"], [data-close]');
    if (focusEl) focusEl.focus();
    document.addEventListener('keydown', onKey);
  };

  const close = () => {
    root.classList.remove('is-open');
    document.body.classList.remove('bloom-emailpop-lock');
    document.removeEventListener('keydown', onKey);
    remember();
    let finished = false;
    const done = () => {
      if (finished) return;
      finished = true;
      root.hidden = true;
      root.removeEventListener('transitionend', done);
    };
    root.addEventListener('transitionend', done);
    window.setTimeout(done, 500); // fallback if transitions are disabled (reduced motion)
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };

  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') trap(e);
  }

  function trap(e) {
    const f = card.querySelectorAll(
      'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'
    );
    if (!f.length) return;
    const first = f[0];
    const last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  root.addEventListener('click', (e) => {
    if (e.target.closest('[data-close]')) { e.preventDefault(); close(); }
  });

  // Just submitted → open in the success state regardless of cooldown.
  if (success) { remember(); open(); return; }

  // Theme editor → open so the merchant can style it.
  if (designMode) { open(); return; }

  if (recentlyDismissed()) return;

  const delay = (Number(root.dataset.delay) || 6) * 1000;
  const timer = window.setTimeout(open, delay);

  // Exit-intent (desktop): cursor leaves toward the top after a short grace period.
  const grace = window.setTimeout(() => {
    document.addEventListener('mouseout', onExit);
  }, 2500);
  function onExit(e) {
    if (e.clientY <= 0 && !e.relatedTarget) {
      window.clearTimeout(timer);
      document.removeEventListener('mouseout', onExit);
      open();
    }
  }
  window.addEventListener('beforeunload', () => {
    window.clearTimeout(timer);
    window.clearTimeout(grace);
  });
})();
